import { render, staticRenderFns } from "./RankingLoading.vue?vue&type=template&id=2d72420a&scoped=true&"
import script from "./RankingLoading.vue?vue&type=script&lang=js&"
export * from "./RankingLoading.vue?vue&type=script&lang=js&"
import style0 from "./RankingLoading.vue?vue&type=style&index=0&id=2d72420a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72420a",
  null
  
)

export default component.exports